import styled from "styled-components";
import { COLORS } from "../../constants/colors";

interface IListDetailHistoric {
    respuestaID: number;
    formularioID: number;
    formularioListadoDetalleID: number;
    fecha: string;
    hora: string;
    codigo: string | null;
    nombre: string;
    active: boolean;
    borderColor?: string;
    textColor?: string;
    usuarioCreadorGUID?: string;
    method?: () => void;
}

const PersonInfo = styled.div<any>`
color: ${(props) => props.textColor} !important;
opacity: ${(props) => !!props.opacity ? props.opacity : 1};
border-bottom: 1px ${COLORS.black_text_color3} solid;
width: 95%;
padding: 1% 0% 0% 0%;
height: 100%;
display: flex;
position: relative;
left: 2.5%;
//transition: all .06s;

.boxContent {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.boxContent h3{
    
    opacity: 0.7;
    margin-bottom: 0px;
}

.boxTitle{
    color:${(props) => props.textColor};
    width: 90%;
    font-weight: 700;
    font-weight: bold;
    display:flex;
}
.boxTitle h1{
        color: ${COLORS.blue_main(1)};
        font-size: x-large;
        font-weight: bold;
        margin-bottom: 0px;
}

.boxSub {
    display: flex;
    flex-direction: row;
    width: 100%;
}
.boxSub-label{
    color: ${COLORS.black_shadow_1}; 
    margin-right: 0.4% ;
}
.boxSub-var{
    color: ${(props) => props.textColor}; 
    margin-right: 2.6% ;
}

.boxIcon-start{
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => props.textColor};
    font-size: x-large;
    width: 5%;
}

.boxIcon-end{
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${COLORS.black_shadow_1};
    font-size: x-large;
    width: 3%;
}

${props => props.active && (`
    cursor: pointer;
    
    :active {
        opacity: 0.7;
    }

    :hover {
        box-shadow: 0px 1px 1px 0px ${COLORS.black_text_color3};
        //transform: scale(1.01);
    }

`)}`;

const EntidadEncuestadaItem: React.FC<IListDetailHistoric> = ({ nombre, codigo, fecha, hora, active, borderColor, textColor, usuarioCreadorGUID, method }) => {

    return (
        <PersonInfo
            borderColor={borderColor}
            textColor={active === true ? textColor : COLORS.white_color1}
            active={active}
            onClick={!!active ? method : null}>
            <div className="boxIcon-start" >{<i className="fa-solid fa-circle-check"></i>}
            </div>
            <div className="boxContent" >
                <div className="boxTitle">
                    <h1>{nombre}</h1>
                </div>
                <div className="boxSub">
                    <h3 className="boxSub-label">{"Codigo: "}</h3>
                    <h3 className="boxSub-var">{codigo}</h3>
                    <h3 className="boxSub-label">{"Fecha: "}</h3>
                    <h3 className="boxSub-var">{new Date(fecha).toLocaleDateString("en-GB")}</h3>
                    <h3 className="boxSub-label">{"Hora: "}</h3>
                    <h3 className="boxSub-var">{new Date(fecha).getHours() + ":" + new Date(fecha).getMinutes() + ":" + new Date(fecha).getSeconds()}</h3>
                    <h3 className="boxSub-label">{"Usuario Creador: "}</h3>
                    <h3 className="boxSub-var">{usuarioCreadorGUID}</h3>
                </div>
            </div>
            <div className="boxIcon-end" >{<i className="fa-solid fa-eye"></i>}
            </div>

        </PersonInfo>
    )
}


export default EntidadEncuestadaItem;